import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, FormGroup, FormSelect, Row } from 'shards-react'
import { graduatesActions, setFormData } from '../../../../redux/reducers/Graduates/graduatesReducer';
import { getYearsList } from '../../../../utils/smallHelpers';
import { ORG_TYPES } from '../../../../constants/const';
import styles from '../styles.module.css'



const yearsList = getYearsList()

const { graduatesRequestStart } = graduatesActions

const Form = ({ form }) => {
  
  const dispatch = useDispatch()
  
  const setYearHandler = (e) => {
    const { value } = e.target
    dispatch(setFormData({ ...form, year: value }))
  }

  const setSchoolHandler = (e) => {
    const { value } = e.target
    dispatch(setFormData({ ...form, school: value }))
  }

  const onSubmit = () => {
    dispatch(graduatesRequestStart())
  }

  return (
    <Row className={styles.formRow}>
        
        <Col md={3}>
          <label htmlFor="year">Выберите год</label>
          <FormSelect
              id='year'
              size="sm"
              value={form.year}
              onChange={setYearHandler}
          >
              {yearsList.map(year => <option key={year} value={year} selected={year === form.year}>{year}</option>)}
          </FormSelect>
        </Col>

        <Col md={3}>
          {/* <FormGroup> */}
            <label htmlFor='_school'>Тип ОО</label>
            <FormSelect
              name='school'
              id='_school'
              size='sm'
              className='md-block'
              onChange={setSchoolHandler}
              value={form.school}
            >
              {ORG_TYPES.map(({name, value}) => <option key={value} value={value}>{name}</option>)}
            </FormSelect>
          {/* </FormGroup> */}
        </Col>

        <Button onClick={onSubmit}>Создать отчет</Button>

    </Row>
  )
}

export default Form